/** Razorpay payments + admin config API for INR ↔ Mu conversion and prep charge. */
import client from './client';

export const paymentsAPI = {
  /** Public config for any authenticated user: current INR-per-Mu ratio + min recharge. */
  getConfig: async () => (await client.get('/payments/config')).data,

  /** Create a Razorpay order. Returns { order_id, amount (paise), key_id, mu_points, inr_per_mu }. */
  createOrder: async (amountInr) =>
    (await client.post('/payments/orders', { amount_inr: Number(amountInr) })).data,

  /** Verify payment signature server-side after Razorpay handler fires. Credits Mu points. */
  verifyPayment: async ({ razorpay_order_id, razorpay_payment_id, razorpay_signature }) =>
    (await client.post('/payments/verify', {
      razorpay_order_id, razorpay_payment_id, razorpay_signature,
    })).data,

  /** Current user's recharge history (successful Razorpay payments). */
  getHistory: async () => (await client.get('/payments/history')).data,
};

/** Admin: INR ↔ Mu conversion + interview-prep charge config. */
export const platformConfigAPI = {
  getConversion: async () => (await client.get('/admin/config/conversion')).data,
  updateConversion: async (inr_per_mu) =>
    (await client.patch('/admin/config/conversion', { inr_per_mu: Number(inr_per_mu) })).data,

  getPrep: async () => (await client.get('/admin/config/prep')).data,
  updatePrep: async (patch) => (await client.patch('/admin/config/prep', patch)).data,
};

/** Applicant-facing prep endpoints tied to the new per-question charge flow. */
export const prepChargeAPI = {
  getConfig: async () => (await client.get('/prep/config')).data,
  chargeQuestion: async (sessionId, questionIndex) =>
    (await client.post(`/prep/${sessionId}/charge-question`, { question_index: questionIndex })).data,
  nextQuestion: async (sessionId) =>
    (await client.post(`/prep/${sessionId}/next-question`)).data,
};

export default paymentsAPI;
